export default __webpack_public_path__ + "static/media/musicas-telainicial.ac73af28.png";